'use client';

import { datadogRum } from '@datadog/browser-rum';
import { useContext, useEffect } from 'react';

import { VisitorContext } from '@/context';

// Syncs after ZIP (and address) updates — DataDogProvider only stamps the SSR cookie at init.
export const DataDogEmbedFootprint = () => {
  const { visitor } = useContext(VisitorContext);
  const inServiceArea = visitor?.meta_values?.embed_in_service_area;

  useEffect(() => {
    if (typeof inServiceArea === 'boolean') {
      datadogRum.setGlobalContextProperty('embed.in_service_area', inServiceArea);
    }
  }, [inServiceArea]);

  return null;
};
